import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { signOut, onAuthStateChanged } from "firebase/auth";
import Spinner from "react-spinkit";

import { auth, login } from "./services/firebase";
import Header from "./components/Header/Header";
import Sidebar from "./components/Sidebar/Sidebar";
import Chat from "./components/Chat/Chat";
import store from "./store/store";
import Login from "./components/Login/Login";
import { AppBody, AppLoading, AppLoadingContents } from "./App.elements";
import Welcome from "./components/Welcome/Welcome";
import NotFound from "./components/NotFound/NotFound";

function App() {
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const loginHandler = () => {
    setLoading(true);
    login()
      .then(() => {
        setLoading(false);
        setIsLoggedIn(true);
      })
      .catch((error) => {
        alert(error.message);
        setLoading(false);
      });
  };

  const logoutHandler = () => {
    signOut(auth).then(() => setIsLoggedIn(false));
  };

  onAuthStateChanged(auth, (user) => {
    if (loading) {
      setLoading(false);
    }

    if (user) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  });

  if (loading) {
    return (
      <AppLoading>
        <AppLoadingContents>
          <img
            src="https://cdn.mos.cms.futurecdn.net/SDDw7CnuoUGax6x9mTo7dd.jpg"
            alt=""
          />

          <Spinner name="ball-spin-fade-loader" color="purple" fadeIn="none" />
        </AppLoadingContents>
      </AppLoading>
    );
  }
  return (
    <div>
      <Provider store={store}>
        <BrowserRouter>
          {!isLoggedIn ? (
            <Login login={loginHandler} />
          ) : (
            <React.Fragment>
              <Header logout={logoutHandler} />
              <AppBody>
                <Sidebar />
                <Routes>
                  <Route exact path="/" element={<Welcome />} />
                  <Route exact path="/channel/:id" element={<Chat />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </AppBody>
            </React.Fragment>
          )}
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
